import R from 'ramda';

export const multiSelectInput = {
	props: [
		'list',
		'itemsIds',
	],

	data() {return {checkedItems: []}},

	methods:  {
		is_checked(id) {
			return R.contains(id, this.checkedItems);
		},

	},

	watch: {
		checkedItems(value) {
			this.itemsIds = value
		}
	},

	ready() {
		this.checkedItems = R.map(n => n, this.itemsIds || []);
	},
};
